import { ActionTree } from 'vuex'
import { ApiVersion, RootState } from '../types'
import { AdminDetail, AdminState, Periods } from './types'
import { AdminMutations } from './mutations'
import { Response } from '../response'
import axios from 'axios'
import { NotificationType, showToast } from '@/utils/Notification'

export const actions: ActionTree<AdminState, RootState> = {
  //Get admin info
  async getAdminDetail({ commit }, acountPeriodId: number) {
    commit(AdminMutations.SET_LOADER, true)
    try {
      const resp = await axios.get(
        `${ApiVersion.V1}/Administration/periods/${acountPeriodId}`
      )

      if (resp?.data) {
        const response: Response<AdminDetail> = resp?.data

        commit(AdminMutations.SET_ADMINDETAIL, response?.data ?? undefined)
      } else {
        showToast(
          NotificationType.WARNING,
          'No se recuperó información para el periodo seleccionado'
        )
        commit(AdminMutations.SET_ADMINDETAIL, undefined)
      }
    } catch (error) {
      console.error(error)
      showToast(
        NotificationType.WARNING,
        'No se recuperó información para el periodo seleccionado'
      )
      commit(AdminMutations.SET_ADMINDETAIL, undefined)
    } finally {
      commit(AdminMutations.SET_LOADER, false)
    }
  },

  //Get periods
  async getPeriods({ commit }) {
    commit(AdminMutations.SET_LOADER, true)
    try {
      const { data } = await axios.get(
        `${ApiVersion.V1}/Administration/periods`
      )
      const response: Response<Array<Periods>> = data

      commit(AdminMutations.SET_PERIODS, response.data)
    } catch (error) {
      console.error(error)
    } finally {
      commit(AdminMutations.SET_LOADER, false)
    }
  }
}
